<template>
  <b-modal
    v-model="visible"
    title="Nova pré-análise"
    centered
    ok-only
    :ok-disabled="!canCreateLocalAnalysis"
    @ok="handleCreate"
  >
    <b-form-group label="Proposta">
      <b-form-select
        v-model="localAnalysis.product_id"
        :options="proposalOptions"
        required
      />
    </b-form-group>

    <b-form-group label="Capital social">
      <b-form-input
        v-model="localAnalysis.capital_social"
        v-money="money"
        autocomplete="off"
        required
      />
    </b-form-group>

    <b-form-group label="Faturamento anual">
      <b-form-input
        v-model="localAnalysis.annual_revenue"
        v-money="money"
        autocomplete="off"
        required
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormSelect
} from 'bootstrap-vue'

export default {
  name: 'NewAnalysisModal',

  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    analysis: {
      type: Object,
      default: () => ({
        product_id: null,
        capital_social: '',
        annual_revenue: ''
      })
    },

    creditProducts: {
      type: Array,
      default: () => []
    },

    canCreateAnalysis: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localAnalysis: {
        product_id: null,
        capital_social: '',
        annual_revenue: ''
      }
    }
  },

  computed: {
    proposalOptions() {
      return [
        {
          value: null,
          text: 'Escolha uma opção',
          disabled: true
        },
        ...this.creditProducts.filter(product => product.value !== '')
      ]
    },

    canCreateLocalAnalysis() {
      return Boolean(
        this.localAnalysis.product_id &&
        this.localAnalysis.capital_social &&
        this.localAnalysis.annual_revenue
      )
    },

    visible: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.localAnalysis = {
            ...this.analysis
          }
        }
      }
    }
  },

  methods: {
    handleCreate() {
      this.$emit('create', {
        ...this.localAnalysis
      })
    }
  }
}
</script>

<style scoped>
.form-control:focus,
.custom-select:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}
</style>
